"use client";

import PhosphorIcon from "@/shared/components/common/PhosphorIcon";

interface DetailRouteErrorStateProps {
  onRetry: () => void;
}

export default function DetailRouteErrorState({
  onRetry,
}: DetailRouteErrorStateProps) {
  return (
    <main className="flex min-h-[70vh] items-center bg-[#f5f6f8] px-4 py-12">
      <div className="mx-auto w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
          <PhosphorIcon name="WarningCircle" size={28} weight="duotone" />
        </span>
        <h1 className="text-lg font-bold text-slate-950">
          اطلاعات هتل در دسترس نیست
        </h1>
        <p className="mt-2 text-sm leading-7 text-slate-500">
          دریافت اطلاعات این هتل با مشکل روبه‌رو شد. دوباره تلاش کنید.
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-6 inline-flex items-center justify-center rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-white"
        >
          تلاش دوباره
        </button>
      </div>
    </main>
  );
}
